module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_13-f3a0640abc4b9499d32c54dd0bd5bd6b.jpg";